<mat-toolbar>
    <div class="copyright-container">
        <span>
            © {{ year }} <a target="_blank" href="http://www.thenet.group/">The Net Group</a>All Rights Reserved
        </span>
    </div>
</mat-toolbar>